// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../../../library/NetworkUtils.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as BlacklistPartnerRepoConfig from "./BlacklistPartnerRepoConfig.bs.js";

var dummyBlacklistResponse = {
      "message": "Partner blacklisted successfully",
      "success": true
    };

var dummyWhitelistResponse = {
      "message": "Partner whitelisted successfully",
      "success": true
    };

function blacklistPartner(payload, _country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      setTimeout((function (param) {
                              return resolve({
                                          TAG: /* Success */0,
                                          _0: dummyBlacklistResponse
                                        });
                            }), 1000);
                      
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(BlacklistPartnerRepoConfig.BlacklistPartnerResponseConverter.execute, result);
                            });
                }), "dummyBlacklistPartner");
}

function whitelistPartner(payload, _country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      setTimeout((function (param) {
                              return resolve({
                                          TAG: /* Success */0,
                                          _0: dummyWhitelistResponse
                                        });
                            }), 1000);
                      
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(BlacklistPartnerRepoConfig.BlacklistPartnerResponseConverter.execute, result);
                            });
                }), "dummyWhitelistPartner");
}

var BlacklistPartnerRepo = {
  blacklistPartner: blacklistPartner,
  whitelistPartner: whitelistPartner
};

export {
  BlacklistPartnerRepo ,
  
}
/* NetworkUtils Not a pure module */
